// API Configuration
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
    BASE_URL: API_URL,
    CHECK_USER: `${API_URL}/api/check-user`,
    GET_FORMULAIRE: (id) => `${API_URL}/api/formulaire/${id}`,
    SAVE_FORMULAIRE: `${API_URL}/api/formulaire`,
    // Admin endpoints
    ADMIN_USERS: `${API_URL}/api/admin/users`,
    ADMIN_CREATE: `${API_URL}/api/admin/users`,
    ADMIN_DELETE_USER: (id) => `${API_URL}/api/admin/users/${id}`,
    ADMIN_ANALYTICS: `${API_URL}/api/admin/analytics`,
    HEALTH: `${API_URL}/api/health`
};

export default API_URL;
